import * as ActionTypes from "../actions/types";

const INITIAL_STATE = {
  errorMessage: null,
  loadingSumAggregatesPerEndpoint: false,
  sumAggregatesPerEndpoint: [],
  loadingSumAggregatesPerEndpointPerDay: false,
  sumAggregatesPerEndpointPerDay: [],
  analyticsAreEnabled: false,
  checkingIfAnalyticsAreEnabled: false,
};

const fetchAggregatesPerEndpointStatistics = (state, action) => {
  state.loadingSumAggregatesPerEndpoint = true;
};

const fetchAggregatesPerEndpointPerDayStatistics = (state, action) => {
  state.loadingSumAggregatesPerEndpointPerDay = true;
};

const fetchAggregatesPerEndpointStatisticsSuccess = (state, action) => {
  state.loadingSumAggregatesPerEndpoint = false;
  state.sumAggregatesPerEndpoint = action.payload.body?.payload || [];
};

const fetchAggregatesPerEndpointStatisticsFailed = (state, action) => {
  state.loadingSumAggregatesPerEndpoint = false;
};

const fetchAggregatesPerEndpointPerDayStatisticsSuccess = (state, action) => {
  state.loadingSumAggregatesPerEndpointPerDay = false;
  state.sumAggregatesPerEndpointPerDay = action.payload.body?.payload || [];
};

const fetchAggregatesPerEndpointPerDayStatisticsFailed = (state, action) => {
  state.loadingSumAggregatesPerEndpointPerDay = false;
};

const checkIfAnalyticsAreEnabled = (state, action) => {
  state.checkingIfAnalyticsAreEnabled = true;
};

const checkIfAnalyticsAreEnabledSuccess = (state, action) => {
  state.checkingIfAnalyticsAreEnabled = false;
  state.analyticsAreEnabled = action.payload.body?.payload === true;
};

const checkIfAnalyticsAreEnabledFailed = (state, action) => {
  state.checkingIfAnalyticsAreEnabled = false;
};

export const analytics = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.FETCH_AGGREGATES_PER_ENDPOINT_STATISTICS]:
      fetchAggregatesPerEndpointStatistics,
    [ActionTypes.FETCH_AGGREGATES_PER_ENDPOINT_STATISTICS_SUCCESS]:
      fetchAggregatesPerEndpointStatisticsSuccess,
    [ActionTypes.FETCH_AGGREGATES_PER_ENDPOINT_STATISTICS_FAILED]:
      fetchAggregatesPerEndpointStatisticsFailed,
    [ActionTypes.FETCH_AGGREGATES_PER_ENDPOINT_PER_DAY_STATISTICS]:
      fetchAggregatesPerEndpointPerDayStatistics,
    [ActionTypes.FETCH_AGGREGATES_PER_ENDPOINT_PER_DAY_STATISTICS_SUCCESS]:
      fetchAggregatesPerEndpointPerDayStatisticsSuccess,
    [ActionTypes.FETCH_AGGREGATES_PER_ENDPOINT_PER_DAY_STATISTICS_FAILED]:
      fetchAggregatesPerEndpointPerDayStatisticsFailed,
    [ActionTypes.CHECK_IF_ANALYTICS_ARE_ENABLED]: checkIfAnalyticsAreEnabled,
    [ActionTypes.CHECK_IF_ANALYTICS_ARE_ENABLED_SUCCESS]:
      checkIfAnalyticsAreEnabledSuccess,
    [ActionTypes.CHECK_IF_ANALYTICS_ARE_ENABLED_FAILED]:
      checkIfAnalyticsAreEnabledFailed,
  },
};
